// store/index.js (manager)
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_notifications: [],
    user: {},
    username: '',
    current_app_feature: "",
    user_info_state: false,
    user_info: {},          // ⚠️ important : contiendra user.id
    unread_user_notifications: 0,
    isAuthenticated: false,
    lengthActiveCampaigns: 0,
    token: '',
    isLoading: false,
    isSavings: false,
    isMarketPlace: false,
    isNjangi: false,
    isFundraising: false,
    isMonitor: false,
    isStatusPasswordRequestStatus: false,
    isBusiness_account: false,
    snackBar: false,
    snackBarColor: "",
    snackBarMessage: "",
    snackBarTimeOut: 4000,
    hideFloatChat: false,
    dialog: false,
    dialog_title: "",
    dialog_message: "",
    shopping_bag: {
      items: [],
    },
    notification_counts: {
      deposit_requests:             0,
      withdrawal_requests:          0,
      interrupt_requests:           0,
      business_requests:            0,
      partnership_requests:         0,
      loan_requests:                0,
      investment_payments:          0,
      security_lockouts:            0,
      seller_applications:          0,
      seller_events:                0,
      reseller_applications:        0,
      reseller_events:              0,
      njangi_pending_groups:        0,
      njangi_join_requests:         0,
      njangi_contribution_requests: 0,
    },
    notification_total: 0,
  },

  mutations: {
    initialiseStore(state) {
      if (localStorage.getItem('token')) {
        state.token = localStorage.getItem('token')
        state.isAuthenticated = true
      } else {
        state.token = ''
        state.isAuthenticated = false
      }

      // Restauration des flags
      const flags = ['isSavings', 'isMarketPlace', 'isNjangi', 'isFundraising', 'isMonitor', 'isBusiness_account']
      flags.forEach(key => {
        if (localStorage.getItem(key)) {
          state[key] = JSON.parse(localStorage.getItem(key))
        } else {
          localStorage.setItem(key, JSON.stringify(state[key]))
        }
      })

      console.log('state.user')
    },

    addToShoppingBag(state, item) {
      const exists = state.shopping_bag.items.filter(i => i.product.id === item.product.id)
      if (exists.length) {
        exists[0].quantity = parseInt(exists[0].quantity) + parseInt(item.quantity)
      } else {
        state.shopping_bag.items.push(item)
      }
      localStorage.setItem('shopping_bag', JSON.stringify(state.shopping_bag))
    },

    resetShoppingBag(state) {
      state.shopping_bag = { items: [] }
      localStorage.setItem('shopping_bag', JSON.stringify(state.shopping_bag))
    },

    setToken(state, token) {
      state.token = token
      state.isAuthenticated = true
    },

    removeToken(state) {
      state.token = ''
      state.isAuthenticated = false
    },

    setAppFeature(state, feature) {
      state.current_app_feature = feature
    },

    setIsLoading(state, status) {
      state.isLoading = status
    },

    setLocalStorageProduct(state) {
      const flags = ['isSavings', 'isMarketPlace', 'isNjangi', 'isFundraising', 'isMonitor', 'isBusiness_account']
      flags.forEach(key => {
        localStorage.setItem(key, JSON.stringify(state[key]))
      })
    },

    // Mutations pour basculer les onglets
    setIsSavings(state, status) {
      state.isSavings = status
      state.isMarketPlace = false
      state.isNjangi = false
      state.isFundraising = false
      state.isMonitor = false
      state.isBusiness_account = false
    },
    setIsMarketPlace(state, status) {
      state.isSavings = false
      state.isMarketPlace = status
      state.isNjangi = false
      state.isFundraising = false
      state.isMonitor = false
      state.isBusiness_account = false
    },
    setIsNjangi(state, status) {
      state.isSavings = false
      state.isMarketPlace = false
      state.isNjangi = status
      state.isFundraising = false
      state.isMonitor = false
      state.isBusiness_account = false
    },
    setIsFundraising(state, status) {
      state.isSavings = false
      state.isMarketPlace = false
      state.isNjangi = false
      state.isFundraising = status
      state.isMonitor = false
      state.isBusiness_account = false
    },
    setIsMonitor(state, status) {
      state.isSavings = false
      state.isMarketPlace = false
      state.isNjangi = false
      state.isFundraising = false
      state.isMonitor = status
      state.isBusiness_account = false
    },
    setIsBusiness_account(state, status) {
      state.isSavings = false
      state.isMarketPlace = false
      state.isNjangi = false
      state.isFundraising = false
      state.isMonitor = false
      state.isBusiness_account = status
    },

    setNotificationCounts(state, { counts, total }) {
      state.notification_counts = { ...state.notification_counts, ...counts }
      state.notification_total = total
    },

    resetCategoryCount(state, category) {
      if (state.notification_counts.hasOwnProperty(category)) {
        state.notification_counts[category] = 0
        state.notification_total = Object.values(state.notification_counts).reduce((sum, v) => sum + v, 0)
      }
    },

    setIsStatusPasswordRequestStatus(state, status) {
      state.isStatusPasswordRequestStatus = status
    },

    setLengthActiveCampaigns(state, length) {
      state.lengthActiveCampaigns = length
    },

    // Dialog / Snackbar
    activateDialog(state, status) {
      state.dialog = status
    },
    setDialogTitle(state, title) {
      state.dialog_title = title
    },
    setDialogMessage(state, message) {
      state.dialog_message = message
    },
    activateSnackBar(state, status) {
      state.snackBar = status
    },
    setSnackBarMessage(state, message) {
      state.snackBarMessage = message
    },
    setSnackBarColor(state, color) {
      state.snackBarColor = color
    },
    setSnackBarTimeOut(state, timeout) {
      state.snackBarTimeOut = timeout
    },
    setHideFloatChat(state, status) {
      state.hideFloatChat = !!status
    },

    // Notifications utilisateur
    setUserNotifications(state) {
      axios
        .get('/api/v1/home/get/user/notifications/')
        .then(response => {
          state.user_notifications = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    setUnreadUserNotifications(state) {
      let no_unread = 0
      for (const notification of state.user_notifications) {
        if (!notification.read) no_unread++
      }
      state.unread_user_notifications = no_unread
    },

    // Mise à jour des infos utilisateur (ajouté pour le getter userId)
    setUserInfo(state, user_info) {
      state.user_info = user_info
    },

    setUserName(state, username) {
      state.username = username
    },
  },

  actions: {
    async fetchNotificationCounts({ commit, state }) {
      if (!state.isAuthenticated) return
      try {
        const { data } = await axios.get(
          '/api/v1/manager/notifications/badge-counts/',
          { headers: { Authorization: `Token ${state.token}` } }
        )
        if (data.success) {
          commit('setNotificationCounts', {
            counts: data.counts,
            total: data.total_unread,
          })
        }
      } catch (e) {
        // silencieux
      }
    },

    async markCategoryRead({ commit, state }, category) {
      try {
        await axios.post(
          '/api/v1/manager/notifications/mark-category-read/',
          { category },
          { headers: { Authorization: `Token ${state.token}` } }
        )
        commit('resetCategoryCount', category)
      } catch (e) {
        // silencieux
      }
    },
  },

  getters: {
    // 🆕 GETTER : ID utilisateur pour l'abonnement WebPush
    userId: (state) => state.user_info?.id || state.username || 'anonymous',
  },
})
